/**
 * @file_purpose  component created for banner section on web page
 * @author Swarnali Ghosh
 * @Date_Created 28-02-2024
 * @Date_Modified 01-03-2024
 */

import React from 'react'
import BAN from '../../assets/images/ban.png';
import BAN1 from '../../assets/images/ban1.png';
import BAN2 from '../../assets/images/ban2.png';

const WebBanner = () => {
    return (
        <>
            <div id="carouselExampleIndicators" className="carousel slide carousel-fade" data-bs-ride="carousel">
                <div className="carousel-indicators">
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to={0} className="active" aria-current="true" aria-label="Slide 1" />
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to={1} aria-label="Slide 2" />
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to={2} aria-label="Slide 3" />
                </div>
                <div className="carousel-inner">
                    <div className="carousel-item active">
                        <img src={BAN} className="d-block w-100" alt="..." />
                    </div>
                    <div className="carousel-item">
                        <img src={BAN1} className="d-block w-100" alt="..." />
                    </div>
                    <div className="carousel-item">
                        <img src={BAN2} className="d-block w-100" alt="..." />
                    </div>
                </div>
                <button className="prev_sec" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true" />
                    <span className="visually-hidden">Previous</span>
                </button>
                <button className="next_sec" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true" />
                    <span className="visually-hidden">Next</span>
                </button>
            </div>
        </>
    )
}

export default WebBanner
